import type Shop from '@/models/Shop'

export default class Account {
  id: string
  company_name?: string
  first_name?: string
  last_name?: string
  street?: string
  street_number?: string
  address2?: string
  postal_code?: string
  city?: string
  country?: string
  variants?: Shop[]
}

/** What a shop is registered with, on top of the account's own fields. */
export interface ShopRegistration extends Partial<Account> {
  instore_channel_id: string
  accept_suisa: boolean
}

export function accountDisplayName(account?: Partial<Account>): string {
  if (!account) return ''
  return account.company_name
    || [account.first_name, account.last_name].filter(Boolean).join(' ')
    || ''
}
